export const environment = {
  production: false,
  apiHost: {
    caerus: `/api/caerus/`,
    athena: `/api/athena/`,
    odin: `/api/odin/`,
    coordinator: `/api/coordinator/`,
    bifrost: `/api/bifrost/`,
    bva: `/api/bva/`,
    atlas: `/api/atlas/`,
    metis: `/api/metis/`,
    saga: `/api/saga/`,
    // anubis is same-origin by design: no Azure SDK and no CORS in the browser.
    anubis: `/api/submissions/`,
  },
  idleTimeout: 4 * 60 * 60,
  idleWarnTime: 1 * 60 * 60,
  autocompleteDebounceTime: 250,
  chironUrlsPostfix: 'dev.biomedata.io',
  auditorUrl: 'https://auditor.stag.biome.ws',
  jiraUrl: 'https://biome-analytics.atlassian.net',
  supportDeskUrl:
    'https://biome-analytics.atlassian.net/servicedesk/customer/portals',
  gatewayUrls: [
    'https://bifrost.dev.biomedata.io',
    'https://ten.dev.biomedata.io',
    'https://localhost:3005',
  ],
  bvaSocketUrl: 'https://va.dev.biomedata.io',
  isDev: true,
  enableAppCache: true,
  showDisclaimer: false,
  release: 'tiramisu',
  agGridLicenseKey:
    'Using_this_{AG_Grid}_Enterprise_key_{AG-081652}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Biome}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{Biome}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{Biome}_need_to_be_licensed___{Biome}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_December_2026}____[v3]_[01]_MTc5NzI5MjgwMDAwMA==c7d9f08cc16e1ebb28f74a71e6ba41b8',
  appInsightsConnectionString:
    'InstrumentationKey=18d9bfb6-6dc6-4aea-ab7f-3ecf9f25da45;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/',
  posthogKey: 'phc_4O87YTguoxeEJ3Sc3nrOVSLqs4DUPeSjPOu0AkETNGp',
  submissionStatusFeatureKey: 'showSubmissionStatusDev',
  riskAuditImprovementChartFeatureKey:
    'disableAuditImprovementOverviewChartDev',
  useEntraIdFeatureKey: 'useEntraIdDev',
  useActiveDirectoryFeatureKey: 'useActiveDirectoryDev',
  patientListOnAdlFeatureKey: 'patientListOnAdlDev',
  riskAdjustedViewFeatureKey: 'enableRiskAdjustedForBiome',
  apolloRolledOutFeatureKey: 'apolloRolledOutFlagDev',
  apolloNextFeatureKey: 'apolloNextDev',
  excludedDatasetsAndTenantsFeatureKey: 'excludedDatasetsAndTenantsDev',
  bvaV2EnabledFeatureKey: 'bvaV2EnabledDev',
  bvaEnabledFeatureKey: '',
  // The Anubis top-panel icon (PE-17021). The icon only — the /data-submission route and
  // the anubis backend do not read it. One key per environment because every
  // chiron build shares one PostHog project.
  anubisMenuFeatureKey: 'show-anubis-menu-dev',
  bvaDebugModeForBiomeFeatureKey: 'bvaDebugModeForBiomeDev',
  echoWorkflowBulkFeatureKey: 'echoWorkflowBulkDev',
  echoWorkflowSingleFeatureKey: 'echoWorkflowSingleDev',
  engagementLevelSnapshotsFeatureKey: 'engagement-level-snapshots-dev',
  clientSubmissionStatusFeatureKey: 'clientSubmissionStatusDev',
  hideSimilaritySearchScores: false,
};
